import React, { useRef, useEffect, useState } from 'react';

import { AmityCommentTrayComponent } from '@frn/amityco-ui-kit-open-source';
// eslint-disable-next-line import/no-webpack-loader-syntax
import socialPlusStyles from '!!css-loader?{"sourceMap":false,"exportType":"string"}!@frn/amityco-ui-kit-open-source/dist/index.css';

import ErrorBoundary from '../ErrorBoundary';

export function SocialPlusComments(props) {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  /*
    The CommentComposeBar component that is loaded in the AmityCommentTrayComponent likes to steal focus on when it is 
    mounted which causes the page to scroll. To prevent this, we use an IntersectionObserver to only allow interaction 
    (and thus mount the CommentComposeBar) when it is in view.
  */

  useEffect(() => {
    const observer = new window.IntersectionObserver(
      ([entry]) => {
        setInView(entry.isIntersecting);
        if (entry.isIntersecting) observer.unobserve(ref.current);
      },
      { threshold: 0.1 }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) observer.unobserve(ref.current);
    };
  }, []);
  return (
    <div ref={ref}>
      <style type="text/css" scoped>
        {socialPlusStyles}
      </style>
      <h4>Leave a comment…</h4>
      <AmityCommentTrayComponent shouldAllowCreation={inView} community={{ isJoined: true }} {...props} />
    </div>
  );
}

export default props => (
  <ErrorBoundary msg="Error loading the comments, please refresh your browser.">
    <SocialPlusComments {...props} />
  </ErrorBoundary>
);
